import { observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { Alert, Col, Container, Row, Button } from 'react-bootstrap';
import { RootStoreContext } from '../../stores/RootStore';
import successMp3 from '../../audio/Success.mp3';
import { renderErrorMessageWithLink } from 'src/stores/ErrorMessages';
import { ErrorCode } from 'src/stores/RegistrationStore';
import { StepName } from 'src/config/Wizard';

const RegistrationPartialSuccessStep = observer(() => {
  const {
    wizardStore: { setStep },
    registrationStore: { partialSuccesses, partialFailures, restart, clearError, user },
    authStore: { isAdminFlow },
  } = useContext(RootStoreContext);
  useEffect(() => {
      const errorAudio = new Audio(successMp3);
      errorAudio.play();
  }, []);

  const toSelectSellingItems = () => {
    clearError();
    setStep(StepName.REGISTRATION_SELECT_TRAINING);
  };

  return (
    <Container>
      <Row>
        <Col
          lg={{ span: 6, offset: 3 }}
          md={{ span: 8, offset: 2 }}
          className="phone"
        >
            {partialSuccesses.length > 0 && (
              <>
            <Alert variant="success">
                Successfully booked: <br />
                <ul>
                  {partialSuccesses.map((item) => (
                    <li key={item.id || item.trainingPeriodId || item.eventId}>
                      {item.title}
                    </li>
                  ))}
                </ul>
                <br />
                Remaining coins: {user.latestTrainingPackage.availableCoins}
          </Alert>
              </>
            )}
            {partialFailures.length > 0 && (
              <>
                <Alert variant={'danger'}>
                  Failed to Book: <br />
                  <ul>
                    {partialFailures.map(({ item, error }) => (
                      <li key={item.id || item.trainingPeriodId || item.eventId}>
                          {item.title}: {Object.values(ErrorCode).includes(error.message as ErrorCode) 
                            ? renderErrorMessageWithLink(error.message as ErrorCode).text 
                            : error.message}
                      </li>
                    ))}
                  </ul>
                </Alert>
              </>
            )}
            <Col className="phone" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
              {isAdminFlow && (
                <Button variant="info" onClick={restart}>Start over</Button>
              )}

              <Button variant="outline-info" onClick={toSelectSellingItems}>Back to selection</Button>
            </Col>
           
        </Col>
      </Row>
    </Container>
  );
});

export default RegistrationPartialSuccessStep;

